// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f79f058","239":"26b9c89d","455":"2fe4d34e"}[chunkId] + ".chunk.js";
};